/**
 * MoreInfoCircle — outlined `i` inside a circle.
 *
 * Uses `currentColor` for both stroke and the dot fill, so it inherits text
 * color and animates smoothly via CSS transitions on `color`.
 */
export function MoreInfoCircle({ width = '1em', height = '1em', className, ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="more_info_circle_icon" 
      data-name="more_info_circle_icon"
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      className={className}
      {...rest}
    >
      <circle className={className} cx="12" cy="12" r="10.5"/>
      {/* i's body */}
      <polyline className={className} points="12 16.77 12 10.09 10.09 10.09"/>
      {/* i's base line */}
      <line className={className} x1="10.09" y1="16.77" x2="13.91" y2="16.77"/>
      {/* i's dot */}
      <line className={className} x1="11.05" y1="7.23" x2="12.95" y2="7.23"/>
    </svg>
  )
}